import React, {useRef, useState} from 'react';
import { connect } from 'react-redux';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { hasPermission, hasAtLeastOnePermission, createHistory } from '../../sc-utilities';
import { Redirect } from 'react-router-dom';
import { FindInPage } from '@material-ui/icons';
import LicensePrototypeList from './LicensePrototypeList';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
});

const LicensePrototype = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, licensePrototypeID: null, redirectPath: '' });

    let visible = columns && columns['LicensePrototype'];

    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {hasPermission(permissions, 'license_prototype_load') ?
                    <Tooltip key={`Edit-${rowData.LicensePrototypeID}`} title={translations["license_prototype_details"] || "License prototype details"}>
                        <IconButton
                            id={`edit_license_prototype_${rowData.LicensePrototypeID}`}
                            component='div'
                            onClick={(event) => redirectHandler(`/billing/license-prototype/edit?licensePrototypeID=${rowData.LicensePrototypeID}`)}
                        >
                            <FindInPage />
                        </IconButton>
                    </Tooltip>
                    : null
                }
            </>
        },
        {
            title: translations["name"] || 'Name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["deleted"] || 'Deleted', field: 'Deleted',
            hidden: visible ? visible['Deleted'] : false,
            lookup: { '0': translations['no'] || 'No', '1': translations['yes'] || 'Yes' },
            defaultFilter: ['0'],
            filtering: true,
            width: 100,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Deleted ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
            }
        }
    ];

    if (!hasAtLeastOnePermission(permissions, [
        "license_prototype_load"
    ])) {
        tableColumns.shift();
    }

    const redirectHandler = (path, licensePrototypeID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, licensePrototypeID: licensePrototypeID, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'license_prototype_list') ?
                <LicensePrototypeList
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                    tableRef={tableRef}
                /> 
            : null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(LicensePrototype));